<template>
  <div>
    <Subheader title="My Projects" />

    <div class="app-content-column">
      <div v-if="!dataLoaded">Loading...</div>

      <div v-if="dataLoaded">
        <Pagination :pagination-details="paginationDetails" @update="refreshData($event)" />
        <div v-for="project in projects" :key="project.id" class="project">
          <ProjectCard :project="project" />
        </div>
        <Pagination
          :pagination-details="paginationDetails"
          :hide-pages="true"
          @update="refreshData($event)"
        />
        <div class="button-wrapper is-centered">
          <button class="large-button" @click="handleNewProject">
            Create New Project
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'
import Project from '@/services/projects/index'
import ProjectCard from '@/components/ProjectCard'

import Pagination from '@/components/Pagination'
import { getPaginationDataFromResponse } from '@/services/utils/pagination'

export default {
  name: 'MakerProjectFeed',
  components: {
    Subheader,
    ProjectCard,
    Pagination,
  },
  data() {
    return {
      projectFilters: {
        page: null,
      },
      projects: [],
      dataLoaded: false,
      paginationDetails: {},
    }
  },
  async mounted() {
    this.refreshData()
  },
  methods: {
    refreshData(page = null) {
      let filtersWithPageCount = { ...this.projectFilters }
      if (page) {
        filtersWithPageCount = { ...this.projectFilters, page: page }
      }
      // TODO: Need to add pagination to this endpoint
      Project.api.getMakerProjectFeed({ filters: filtersWithPageCount }).then(data => {
        this.projects = data.results
        this.paginationDetails = getPaginationDataFromResponse(data)
        this.dataLoaded = true
      })
    },
    handleNewProject() {
      this.$router.push({ name: 'NewProject' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/cards';
@import '../styles/mixins/containers';
@import '../styles/mixins/buttons';
@import '../styles/layout';

.project {
  display: flex;
  justify-content: center;
}
</style>
